export default __webpack_public_path__ + "static/media/icon_things-to-do.ed266158.svg";